import React from 'react';

import getConfig from 'next/config';
import { useRouter } from 'next/router';
import Script from 'next/script';

const { publicRuntimeConfig } = getConfig();

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
  }
}

export const GoogleAnalytics = () => {
  const measurementId = publicRuntimeConfig.GA_MEASUREMENT_ID;
  const router = useRouter();

  React.useEffect(() => {
    if (!measurementId || typeof window === 'undefined' || !window.gtag) return;

    const handleRouteChange = (url: string) => {
      window.gtag('config', measurementId, { page_path: url });
    };

    router.events.on('routeChangeComplete', handleRouteChange);
    return () => router.events.off('routeChangeComplete', handleRouteChange);
  }, [router.events, measurementId]);

  if (!measurementId) return null;

  return (
    <>
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}
      />
      <Script strategy="afterInteractive" id="google-analytics-init">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${measurementId}', { page_path: window.location.pathname });
        `}
      </Script>
    </>
  );
};
